<template>
  <div class="nav-container">
    <div class="nav-view">
      <div class="logo">

      </div>
      <div class="btn-view">

      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'Nav',

  data() {
    return {
      nav: ''
    }
  },

  mounted() {

  },

  watch: {
    $route: {
      handler(to) {
        this.nav = to.meta.nav || ''
      },
      immediate: true
    },
  },

  methods: {}

}
</script>
<style lang="scss" scoped>
.nav-container {
}
</style>
